import cx from 'classnames';
import type { FC } from 'react';

import Icon from 'components/Icon/Icon';
import PixWithdrawalForm from 'components/PaymentForm/PixPayments/PixWithdrawalForm';
import type { PaymentPopupDataType } from 'config/types';
import useLayout, { LayoutType } from 'utils/layout';

import type { PopupProps } from '../types';

import styles from './PaymentPopup.module.scss';

const WithdrawalPopup: FC<PopupProps<PaymentPopupDataType>> = ({
  data,
  closePopup,
}) => {
  const layout = useLayout();
  const isMobile = layout === LayoutType.mobile;

  return (
    <div className={cx(styles.wrapper, { [styles.mobile]: isMobile })}>
      <button
        type="button"
        className={styles['close-button']}
        onClick={closePopup}
        data-testid="close"
      >
        <Icon name="close.outline" width={24} height={24} />
      </button>

      {data && (
        <PixWithdrawalForm
          data={data}
          onNavigateToTransactionHistory={closePopup}
        />
      )}
    </div>
  );
};

export default WithdrawalPopup;
